<template>
  <el-container class="content" style="display: block;">
    <el-container class="copy">
		<el-row>
			<div>注意事项:<span class="zhuyi">1.搜索按Enter开始搜索;2.每个一级分类选择一个二级分类,如有需要选择多个的请告知以便做调整;3.选错可以再次点击取消</span></div>
			<div>数据标签:<span id="input">{{lableEx}}</span></div>
			<div><input type="button" value="复制" class="butn" @click="copy()"/><input type="button" class="butn" value="重置" @click="reset()"/></div>

		</el-row>
	</el-container>
	<el-container class="lables">
		<el-row  class="la-list">
			<el-col :span="10" class="first">
				<el-row>
					<div class="search">
						<input type="text" v-model="searchF" @change="loadData()"/>
					</div>
					<div class="add" @click="add(1)" v-if="this.$store.getters.getRole == 'admin' || this.$store.getters.getRole == 'admins' || this.$store.getters.getRole == 'fenxi'">+ 添加</div>
				</el-row>
        <el-row>
         <template>
           <el-table
         	:data="lableFirst"
           height="580"
         	border
         	style="width: 95%;margin-left: 0;text-align: center;margin-top: 2px;">
          <el-table-column
            width="80"
            label="ID"
             >
             <template slot-scope="scope">
                 <div :class="{'choses':choseAF.indexOf(scope.row.id)>-1&&scope.row.id!=choses,'chosess':scope.row.id==choses}">{{scope.row.id}}</div>
             </template>
          </el-table-column>
           <el-table-column
             width="180"
             label="名称"
              >
              <template slot-scope="scope">
                  <div :class="{'choses':choseAF.indexOf(scope.row.id)>-1&&scope.row.id!=choses,'chosess':scope.row.id==choses}" @click="chose(scope.row.id)">{{scope.row.name}}</div>
              </template>
           </el-table-column>
           <el-table-column
             width="130"
             label="图片查看\修改"
              >
             <template slot-scope="scope">
               <el-row v-if="scope.row.img_s == 0">
                 <el-col :span="20" style="text-align: center;margin-top: 20px;" @click.native="seeImg(scope.$index,scope.row)">
                   查看图片
                 </el-col>
              </el-row>
               <el-row v-if="scope.row.img_s == 1">
                 <el-upload
                   class="avatar-uploader"
                   :action="UploadUrl(scope.row.id)"
                   :show-file-list="false"
                   @click.native="ceshi(scope.$index,scope.row.id)"
                   :on-success="handleAvatarSuccess"
                   style="display: inline;">

                   <img v-if="scope.row.img" :src="scope.row.img" class="avatar" style="width: 80px;height: 80px;">
                   <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                 </el-upload>




               </el-row>
             </template>
           </el-table-column>


           <el-table-column

             width="100"
             label="操作"
             v-if="this.$store.getters.getRole == 'admin' || this.$store.getters.getRole == 'admins' || this.$store.getters.getRole == 'fenxi'"
              >
              <template slot-scope="scope">
                <i class="el-icon-delete" @click="dela(scope.row.id)"></i>
              </template>

           </el-table-column>
           </el-table>
         </template>

        </el-row>

			</el-col>
			<el-col :span="4" class="centr"><img  src="../../assets/image/next.jpg"/></el-col>
			<el-col :span="10" class="two">
				<el-row>
					<div class="search">
						<input type="text"  v-model="searchT" @change="loadDataTwo()"/>
					</div>
					<div class="add" @click="add(2)">+ 添加</div>
				</el-row>
				<el-row class="lable-o-l" v-if="this.$store.getters.getRole == 'admin' || this.$store.getters.getRole == 'admins' || this.$store.getters.getRole == 'fenxi'">
					<div class="lable-o" v-for="(item,index) in lableTwo" :class="{'left':index%2==0,'right':index%2!=0,'choses':choseAT.indexOf(item.id)>-1}" :key="index" >
            <span @click="lableC(item.id,item.p_id,item.name)">{{item.name}}</span>
            <span  @click="delb(item.id)" style="float: right;margin-right: 10px;" >X</span>
          </div>

				</el-row>
        <el-row class="lable-o-l" v-else>
        	<div class="lable-o" v-for="(item,index) in lableTwo" :class="{'left':index%2==0,'right':index%2!=0,'choses':choseAT.indexOf(item.id)>-1}" :key="index" >
            <span @click="lableC(item.id,item.p_id,item.name)">{{item.name}}</span>
            <!-- <span  @click="delb(item.id)" style="float: right;margin-right: 10px;" >X</span> -->
          </div>

        </el-row>
			</el-col>
		</el-row>

	</el-container>
	 <el-dialog
	  title="添加"
	  :visible.sync="centerDialogVisible"
	  width="30%"
	  center>
	  <input type="text" class="searchT" v-model="addT"/>
	  <span slot="footer" class="dialog-footer">
		<el-button @click="centerDialogVisible = false">取 消</el-button>
		<el-button type="primary" @click="doAdd()">确 定</el-button>
	  </span>
	</el-dialog>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisibleda"
    width="30%"
    >
    <span>确认删除？</span>
    <span slot="footer" class="dialog-footer">
  	<el-button @click="dialogVisibleda = false">取 消</el-button>
  	<el-button type="primary" @click="doDella()">确 定</el-button>
    </span>
  </el-dialog>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisibledb"
    width="30%"
    >
    <span>确认删除？</span>
    <span slot="footer" class="dialog-footer">
  	<el-button @click="dialogVisibledb = false">取 消</el-button>
  	<el-button type="primary" @click="doDellb()">确 定</el-button>
    </span>
  </el-dialog>
  </el-container>
</template>

<script>

  export default {
    data() {
      return {
        lableFirst:[],
        lableTwo:[],
        chosesT:0,
        choses:0,
        choseAF:[],
        choseAT:[],
        searchF:'',
        searchT:'',
        lable:[],
        lableEx:'',
        centerDialogVisible:false,
        addType:0,
        addT:'',
        token:window.localStorage.getItem('token'),
        userId:window.localStorage.getItem('id'),
        url:this.$store.getters.getUrl,
        dialogVisibleda:false,
        dialogVisibledb:false,
        dela_id:0,
        delb_id:0,
      };
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
	  // var cip = returnCitySN["cip"];
// 	   if(this.$store.getters.getRole != 'admins'){
// 	   		   if(cip !='117.9.19.251' && cip !='60.27.105.250' && cip !='60.27.106.235'){
// 	   			   this.$router.push({ path: '/' })
// 	   		   }
// 	   }
	   this.loadData();
    },

	methods:{
    dela(id){
      this.dela_id = id
      this.dialogVisibleda = true
    },
    delb(id){
      this.delb_id = id
      this.dialogVisibledb = true
    },
    doDella(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{
    			id:this.dela_id
    		},
    		url:'http://y31p.yoooooo.com/index.php/index/data/labledelf'
    	})
    	.then(res=>{
        this.dialogVisibleda = false
    		this.loadData();
    	})
    	.catch(err=>{

    	});
    },
    doDellb(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{
    			id:this.delb_id
    		},
    		url:'http://y31p.yoooooo.com/index.php/index/data/labledelf'
    	})
    	.then(res=>{
        this.dialogVisibledb = false
    		this.loadDataTwo();
    	})
    	.catch(err=>{

    	});
    },
    imgChange(id,img){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          img:img

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/lableImgf'
      })
      .then(res=>{

        this.lableFirst[this.imageId]['img'] = res.data.data




      })
      .catch(err=>{

      });
    },
    seeImg(index,row){
      row['img_s'] = 1

      this.$set(this.lableFirst,index,row);

    },
    ceshi(index,id){
      this.imageId = index
      this.imgId = id
    },
    handleAvatarSuccess(res, file) {


      this.imgChange(this.imgId,file.response.data)
      this.list[this.imageId]['img'] = URL.createObjectURL(file.raw);
    },
    UploadUrl(id){
      // return "http://y31p.yoooooo.com/index.php/index/data/gtellChange?id="+id
      return "http://data3.yoooooo.com/index.php/index/data/pythonImgSave"
    },
		loadData(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchF
				},
				url:'http://y31p.yoooooo.com/index.php/index/data/lableFirstf'
			})
			.then(res=>{
				this.lableFirst = res.data;
        this.lableFirst.forEach(function(item, index) {
            item['img_s'] = 0;
        })
				// console.log(res.data)
			})
			.catch(err=>{

			});
		},
		loadDataTwo(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchT,
					p_id:this.choses
				},
				url:'http://y31p.yoooooo.com/index.php/index/data/lableTwof'
			})
			.then(res=>{
				this.lableTwo = res.data;

			})
			.catch(err=>{

			});
		},
		chose(id){
			this.choses = id;
			this.searchT = '';
			this.loadDataTwo();

		},
		lableC(id,pId,name){
			this.chosesT = id;
			const names = pId+'-'+name;
			if(this.lable.indexOf(names)>-1){
				this.choseAF.splice(this.choseAF.indexOf(pId),1);
				this.choseAT.splice(this.choseAT.indexOf(id),1);
				this.lable.splice(this.lable.indexOf(names),1);
			}else{
				this.lable.push(names);
				this.choseAF.push(pId);
				this.choseAT.push(id);
			}
			this.lableEx =  this.lable.join(',');
		},
		copy(){
			var text = document.getElementById("input");
			  if (document.body.createTextRange) {
				  var range = document.body.createTextRange();
				  range.moveToElementText(text);
				  range.select();
			   } else if (window.getSelection) {
				  var selection = window.getSelection();
				  var range = document.createRange();
				  range.selectNodeContents(text);
				  selection.removeAllRanges();
				  selection.addRange(range);
				  document.execCommand("Copy")
				} else {

				}
		},
		reset(){
			this.lableFirst = [];
			this.lableTwo=[];
			this.chosesT=0;
			this.choses=0;
			this.choseAF=[];
			this.choseAT=[];
			this.searchF='';
			this.searchT='';
			this.lable=[];
			this.lableEx='';
			this.loadData();
		},
		add(type){
			this.addType = type;
			this.centerDialogVisible = true;
		},
		doAdd(){
			let p_id = 0;
			if(this.addType == 2){
				p_id = this.choses;
			}
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'post',
				params:{
					name:this.addT,
					p_id:p_id,
					token:this.token,
					userId:this.userId
				},
				url:'http://y31p.yoooooo.com/index.php/index/data/lableAddf'
			})
			.then(res=>{
				if(res.data.code == 200){
					this.centerDialogVisible = false;
					this.addT = '';
					if(this.addType == 1){
						this.loadData();
					}else{
						this.loadDataTwo();
					}
					this.addType = 0
				}else{
					this.centerDialogVisible = false;
					this.addT = '';
					alert('添加失败')
				}

			})
			.catch(err=>{

			});
		}
	}


  }
</script>

<style>
	.content{
		background: #939AA0;
		width: 100%;
		height: 100%;
	}
	.centr{
		margin-top: 30%;
	}
	.centr img{
		width: 100px;
		height: 50px;
		margin-left: 35px;
	}
	.copy{
		margin-left: 5%;
		margin-right: 5%;
		background: #fff;
		border-bottom: 1px solid #939AA0;
	}
	.copy .el-row{
		margin: 20px 20% 10px 20%;

	}
	.copy .el-row div{
		margin-bottom: 10px;

	}
	.zhuyi{
		color: red;
	}
	.butn{
		color: #F0F8FF;
		background: #FF9400;
		margin-right: 20px;
		border-radius: 5px;
		width: 50px;
	}
	.lables{
		margin-left: 5%;
		margin-right: 5%;
		background: #fff;
		padding-bottom: 35px;
	}
	.lables .la-list{
		margin-top: 50px;
		width: 100%;
		margin-left: 20%;
		margin-right: 20%;
	}
	.first{
		border: 1px solid #c6c6c6;
		height: 700px;
		overflow-y:scroll;
	}
	.first .el-row{
		margin: 20px 10% 20px 10%;
	}
	.search input{
		width: 95%;
		height: 20px;
		margin-bottom: 10px;
		margin-left: 2%;
	}
	.add{
		text-align: center;
		width: 96%;
		background: #c6c6c6;
		height: 22px;
		line-height: 22px;
		margin-left: 2%;
	}

	.lable-o{
		width: 47%;
		text-align: center;
		background: #c6c6c6;
		height: 30px;
		line-height: 30px;
		margin-bottom: 10px;
	}
	.choses{
		background: #f8f1da;
	}
	.chosess{
		background: #ff9400;
	}
	.right{
		float: right;
	}
	.left{
		float: left;
	}
	.two{
		border: 1px solid #c6c6c6;
		height: 700px;
		overflow-y:scroll;
	}
	.two .el-row{
		margin: 20px 10% 20px 10%;
	}
	.searchT{
		width: 80%;
		margin-left: 10%;
		height: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/components/main/lablef.vue